import React, { Component, PureComponent } from "react";
import styles from './partList.module.less'
import { Form, Tooltip, Button, List, Spin, Input, Select, Icon, Popconfirm } from "antd"
import http from "@/http"
import { getInputValue } from "@/utils/tool"
import { connect } from "dva";
import InfiniteScroll from 'react-infinite-scroller';
import classnames from 'classnames';
import { downloadImg } from "@/utils/constant";
import { ImgPreview } from "@/components/Img";
const HttpDevice = http.tokiot.device;
const HttpProduct = http.tokiot.sys.product;
const FormItem = Form.Item;
const Option = Select.Option;

class PartList extends Component {
    state = {
        partList: [],
        productPartList: [],
        loading: false,
        bigImageVisible: false,
        bigImageSrc: ``,
    };
    pages = 3;

    componentDidMount() {
        this.loadProduct();
        this.loadPartList();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.refreshKey != this.props.refreshKey) {
            this.loadProduct();
            this.loadPartList();
        }
    }

    loadProduct = () => {
        const { deviceInfo } = this.props;
        if (deviceInfo && deviceInfo.productId && deviceInfo.productId.length > 0) {
            let data = {
                productId: deviceInfo.productId,
                size: 9999,
            };
            HttpProduct.part.list(data).then((ret) => {
                if (ret && ret.rows && ret.rows.length > 0) {
                    this.setState({ productPartList: ret.rows, });
                } else {
                    this.setState({ productPartList: [], });
                }
            });
        }
    }

    loadPartList = (page = 1, size = 30) => {
        const { deviceInfo } = this.props;
        if (deviceInfo && deviceInfo.id && deviceInfo.id.length > 0) {
            this.setState({ loading: true });
            let data = {
                deviceId: deviceInfo.id,
                page: page,
                size: size,
            };
            HttpDevice.part.list(data).then((ret) => {
                if (ret && ret.rows && ret.rows.length > 0) {
                    this.setState({ partList: ret.rows, loading: false, });
                } else {
                    this.setState({ partList: [], loading: false, });
                }
            });
        }
    }

    submitPart = () => {
        const { form, deviceInfo } = this.props;
        const { validateFieldsAndScroll } = form;
        validateFieldsAndScroll((err, values) => {
            if (err) return;
            let data = {
                deviceId: deviceInfo.id,
                productPartId: values.productPartId,
                count: values.count,
            };
            HttpDevice.part.submit(data).then((ret) => {
                if (ret) {
                    this.loadPartList();
                } else {
                    message.error(`添加失败`);
                }
            });
        })
    }
    deletePart = (id) => {
        let data = {
            id: id,
        };
        HttpDevice.part.delete(data).then((ret) => {
            if (ret) {
                this.loadPartList();
            } else {
                message.error(`删除失败`);
            }
        });
    }

    imageClick = (imageSrc) => {
        this.setState({
            bigImageVisible: !this.state.bigImageVisible,
            bigImageSrc: imageSrc ? imageSrc : ``,
        });
    }

    render() {
        const { partList, bigImageVisible, bigImageSrc, productPartList } = this.state;
        const { form } = this.props;
        const { getFieldDecorator } = form;
        const columns = [
            {
                title: '型号',
                dataIndex: 'productPartModel',
                key: 'productPartModel',
                render: (text, item) => {
                    let imgPath = downloadImg + ((item.productPartImage && item.productPartImage.length > 0) ? item.productPartImage : "");
                    return (
                        <Tooltip title={text} mouseLeaveDelay={0}>
                            <div className={styles.teableValue}>
                                <img className={styles.image} onClick={e => this.imageClick(imgPath)} src={imgPath} />
                                <div className={styles.value}>
                                    {item.productPartName}
                                </div>
                            </div>
                        </Tooltip>

                    )
                },
            },
            {
                width: "1.3rem",
                title: '数量',
                dataIndex: 'count',
                key: 'count',
                render: text => <div className={styles.teableValue}>{text}</div>,
            },
            {
                width: "0.6rem",
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, item) => {
                    return (
                        <div className={styles.teableValue}>
                            <Popconfirm
                                title={'确认删除？'}
                                okText={'确认'}
                                cancelText={'取消'}
                                onConfirm={() => this.deletePart(item.id)}
                            >
                                <Tooltip title={`删除`} mouseLeaveDelay={0}>
                                    <Icon className={styles.icon} type={'close'} />
                                </Tooltip>
                            </Popconfirm>
                        </div>
                    )
                },
            }
        ];

        return <React.Fragment>
            <div className={styles.actionLogMain}>
                <ImgPreview visible={bigImageVisible} onClose={this.imageClick} src={bigImageSrc} />
                <div className={styles.addPart}>
                    <div className={styles.part}>
                        <div className={styles.left}>配件:</div>
                        <div className={styles.right}>
                            <FormItem colon={false} style={{ flexGrow: 1, height: "100%" }}>
                                {getFieldDecorator("productPartId", {
                                    initialValue: null,
                                    rules: [{ required: true, message: '' }],
                                })(
                                    <Select
                                        style={{ width: "100%" }}
                                        getPopupContainer={triggerNode => triggerNode.parentNode}
                                    >
                                        {productPartList.map(item => {
                                            let imgPath = downloadImg + ((item.image && item.image.length > 0) ? item.image : "");
                                            return (
                                                <Option key={item.id} value={item.id}>
                                                    <Tooltip placement="right" title={`${item.name}(${item.model})`}>
                                                        <div className={styles.teableValue}>
                                                            <img className={styles.image2} src={imgPath} />
                                                            <div className={styles.value}>
                                                                {item.name}
                                                            </div>
                                                        </div>
                                                    </Tooltip>
                                                </Option>
                                            )
                                        })}
                                    </Select>
                                )}
                            </FormItem>
                        </div>
                    </div>
                    <div className={styles.count}>
                        <div className={styles.left}>数量:</div>
                        <div className={styles.right}>
                            <FormItem colon={false} style={{ flexGrow: 1, height: "100%" }}>
                                {getFieldDecorator("count", {
                                    initialValue: null,
                                    rules: [{ required: true, message: '' }],
                                })(
                                    <Input placeholder="数量" style={{ width: "100%" }} />
                                )}
                            </FormItem>
                        </div>
                    </div>
                    <Button type="primary" className={styles.button} onClick={e => { this.submitPart() }} >添加</Button>
                </div>
                <div className={styles.header}>
                    <div className={classnames(styles.tableHeader, styles.table)} style={{ border: 0 }}>
                        {columns.map(item => {
                            let style = {};
                            if (item.width)
                                style.width = item.width;
                            else {
                                style.flexGrow = 1;
                                style.flexShrink = 1;
                            }
                            return (
                                <div className={classnames(styles.headerItem)} style={style}>
                                    {item.title}
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className={styles.body}>
                    <InfiniteScroll
                        initialLoad={false}
                        pageStart={0}
                        loadMore={_ => { this.loadActionLog(++this.pages, 10) }}
                        hasMore={!this.state.loading}
                        useWindow={false}
                    >
                        <Spin spinning={this.state.loading}>
                            <List
                                itemLayout="horizontal"
                                dataSource={partList}
                                renderItem={dataItem => {
                                    return (
                                        <div className={styles.table}>
                                            {columns.map(item => {
                                                let style = {};
                                                if (item.width)
                                                    style.width = item.width;
                                                else {
                                                    style.flexGrow = 1;
                                                    style.flexShrink = 1;
                                                }
                                                return (
                                                    <div className={classnames(styles.headerItem)} style={style}>
                                                        {item.render ? item.render(dataItem[item.key], dataItem) : dataItem[item.key]}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )
                                }}
                            >
                            </List>
                        </Spin>
                    </InfiniteScroll>
                </div>
            </div>
        </React.Fragment >
    }
}
export default Form.create()(PartList)